<template>
  <div class="select-item" :class="{selected: selected}">
    <div>
      <span class="head">
        <!-- {{data.name}} -->
        {{ data.hasOwnProperty('translations') ? data.translations[$store.getters['user/lang']] : data.name }}
      </span>
      <div class="item-list" v-if="!selected">
        <span>
          {{$ml.get(data.type)}}
        </span>
        <span v-if="data.type != 'SOLID'">
          <!-- {{$ml.get(`Density`)}} = {{data.density}}kg/L -->
          {{$ml.get(`Density`)}} = {{$store.getters['unit/convert']('kg/L', data.density)}}
          {{$store.getters['unit/getLabel']('kg/L')}}
        </span>
        <span v-for="(value, key, i) in data.nutrients" :key="i">
          {{key}} = {{ ( value.toString() ).substring(0, 5) }}
        </span>
      </div>

      <div
        class="price"
        v-if="selected"
      >
        <app-text-input
          type="number"
          :label="`price per ${data.costUnit}`"
          :hint="currency.symbol"
          v-model="cost"
          @input="saveCost"
        />
      </div>
    </div>
    <div class="percent" v-if="data.type == 'Acid' && data.add">
      <div>
        <!-- <span v-if="!input_flag" @click.stop="input_flag = !input_flag">
          {{percent}}
        </span>
        <input type="number" placeholder="0" @change="input_flag = !input_flag" v-else v-model="percent">
        <div>
          <div class="arrowTop" @click.stop="percent++"></div>
          <div class="arrowBottom" @click.stop="percent > 0 ? percent-- : ''"></div>
        </div> -->
        <app-text-input
          v-model="percent"
          @change="input_flag = !input_flag"
          :min="1"
          :max="100"
          hint="%"
          required
          :label="$ml.get('Acid percentage')"
        ></app-text-input>
      </div>
    </div>
    <i class="material-icons" v-if="!data.add" @click.stop="addFert">add</i>
    <i class="material-icons" v-else @click.stop="removeFert">remove</i>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import API from '@/api'
export default {
  props: {
    data: Object,
    selected: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      percent: 0,
      cost: 0,
      input_flag: false,
    }
  },
  computed: {
    ...mapGetters({
      currency: 'user/currency',
    }),
  },
  methods: {
    addFert: function (e) {
      this.$store.commit('program/fertilizers/addFertilizer', this.data.id);
    },
    removeFert: function (e) {
      this.$store.commit('program/fertilizers/removeFertilizer', this.data.id);
    },
    saveCost: function() {
      return API.fertilizers.saveFertilizerCost({id: this.data.id, price: this.cost, unit: this.data.costUnit})
        .then(res => {
          // console.log(res.data);
        })
        .catch(err => {

        })
    },
  },
  watch: {
    percent: function (val) {
      this.$store.commit('program/fertilizers/updatePercent', {id: this.data.id, percent: val});
    },
    // cost(val) {
    //
    //   // this.$store.commit('program/fertilizers/updateCost', {id: this.data.id, cost: val});
    // },
  },
  created () {
    if (this.data.type == 'Acid' && this.data.percent != null) {
      this.percent = this.data.percent;
    }
    if(this.data.cost) {
      this.cost = this.data.cost;
    }
  }
}
</script>

<style lang="scss" scoped>
.select-item {
  width: 100%;
  padding: 0 20px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgba(76, 80, 86, 0.10);

  > div:first-child {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 10px 0;

    .head {
      color: black;
      font-weight: bold;
      font-size: 18px;
    }
    .item-list {
      width: 100%;
      display: flex;
      flex-wrap: wrap;

      span {
        font-size: 14px;
        color: rgba(76, 80, 86, 0.5);
        padding: 5px 10px;

        &:first-child {
          padding-left: 0;
        }
        :first-letter {
          text-transform: uppercase;
        }
      }
    }
  }
  .app-text-input {
    margin-top: 24px;
  }
  .percent {
    padding: 10px 10px;
    height: 100%;
    // border-left: 1px solid rgba(76, 80, 86, 0.10);
    // border-right: 1px solid rgba(76, 80, 86, 0.10);
    display: flex;
    // align-items: center;

  }

  .material-icons {
    font-weight: bold;
    color: $mainGreen;
    cursor: pointer;
    padding-left: 20px;
  }
  &.selected {
    align-items: flex-end;
    .material-icons {
      align-self: center;
    }
    > div {
      flex-wrap: wrap;
       div.price {
         flex-basis: 80%;
       }
       div.percent {
        flex-basis: 100%;
        order: 3;
      }
    }
  }
}
</style>
